<template>
  <component
    :is="server ? 'v-data-table-server' : 'v-data-table'"
    class="default-panel default-content--text"
    :class="[{ 'row-pointer': 'onClick:row' in $attrs }, `elevation-${elevation}`]"
    v-bind="tableAttrs"
  >
    <template v-for="(_, slot) in $slots" #[slot]="slotProps">
      <slot :name="slot" v-bind="slotProps || {}" />
    </template>
  </component>
</template>

<script>
export default {
  name: 'BaseDataTable',

  inheritAttrs: false,

  props: {
    elevation: {
      type: [String, Number],
      default: 2,
    },
    /**
     * When true, render v-data-table-server so items-length (API meta.total)
     * drives pagination — plain v-data-table only counts the current page.
     */
    server: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    tableAttrs() {
      const attrs = { ...this.$attrs };

      if (Array.isArray(attrs.headers)) {
        attrs.headers = attrs.headers.map((header) => ({
          ...header,
          title: header.title ?? header.text ?? '',
          key: header.key ?? header.value ?? '',
        }));
      }

      // V3: boolean loading uses props.color (often unset → grey bar).
      // Master V2 used primary blue; pass color via loading string instead of
      // setting table color (which would tint headers/selection).
      if (attrs.loading === true || attrs.loading === '') {
        attrs.loading = 'primary';
      }

      return attrs;
    },
  },
};
</script>
